import { toastService } from '@thefarmersfront/kitchen';

import { useAPI, useAsyncHandler } from '~/hooks/common';
import { addIf } from '~/utils';

import { API_ENDPOINT, STOCK_RELEASE_PALLET_INFO_REQUIRED_CODES, TOAST_MESSAGE } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostVendorReleaseParams, TypeStockReleaseRegisterFieldState } from '~/types/stock.types';

/**
 * [재고관리] 반출 요청 등록 api 요청 훅
 */
const usePostVendorRelease = () => {
  const { runAsync } = useAsyncHandler();

  const postVendorRelease = useAPI<TypePostVendorReleaseParams>({
    endpoint: API_ENDPOINT.STOCK.POST_VENDOR_RELEASE,
    method: 'post',
  });

  const requestVendorReleaseRegister = async (
    { clusterCode, detailInfo, palletInfo, requestSkus }: { clusterCode: string } & TypeStockReleaseRegisterFieldState,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: () => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    } = {}
  ) => {
    const params: TypePostVendorReleaseParams = {
      detailInfo: {
        ...detailInfo,
        clusterCode,
        phoneNumber: detailInfo.phoneNumber.replace(/-/g, ''),
      },
      ...addIf(STOCK_RELEASE_PALLET_INFO_REQUIRED_CODES.includes(detailInfo.packingMethod), 'palletInfo', {
        ...palletInfo,
        managerPhoneNumber: palletInfo?.managerPhoneNumber.replace(/-/g, ''),
      }),
      skuList: requestSkus.map(({ skuCode, availableRequestQuantity = 0, defectiveRequestQuantity = 0 }) => ({
        skuCode,
        availableRequestQuantity,
        defectiveRequestQuantity,
      })),
    };

    runAsync(() => postVendorRelease({ params }), {
      onSuccess: () => {
        toastService.addToast({
          message: '등록 되었습니다.',
        });
        onSuccess?.();
      },
      onError: (error: TypeErrorResponseData['error']) => {
        toastService.addToast({
          type: 'error',
          message: error.message ?? TOAST_MESSAGE.DEFAULT_ERROR,
        });
        onError?.(error);
      },
    });
  };

  return { requestVendorReleaseRegister };
};

export default usePostVendorRelease;
